var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlayCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.16683 11.0007V5.00065L11.1668 8.00065M8.50016 1.33398C7.62468 1.33398 6.75778 1.50642 5.94894 1.84145C5.1401 2.17649 4.40517 2.66755 3.78612 3.28661C2.53587 4.53685 1.8335 6.23254 1.8335 8.00065C1.8335 9.76876 2.53587 11.4645 3.78612 12.7147C4.40517 13.3338 5.1401 13.8248 5.94894 14.1598C6.75778 14.4949 7.62468 14.6673 8.50016 14.6673C10.2683 14.6673 11.964 13.9649 13.2142 12.7147C14.4644 11.4645 15.1668 9.76876 15.1668 8.00065C15.1668 7.12517 14.9944 6.25827 14.6594 5.44943C14.3243 4.64059 13.8333 3.90566 13.2142 3.28661C12.5951 2.66755 11.8602 2.17649 11.0514 1.84145C10.2425 1.50642 9.37564 1.33398 8.50016 1.33398Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayCircle);
export default __webpack_public_path__ + "static/media/play-circle.add71f06034ca8f1b5d3ae9e8ba2c74f.svg";
export { ForwardRef as ReactComponent };